import { Box, Typography } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

const LoadingIndicator = ({
  className,
  type = 'fixed',
  label,
}: {
  className?: string;
  type?: 'block' | 'inline' | 'fixed';
  label?: string;
}) => {
  const commonSx = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
  };

  const typeSx = {
    fixed: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
    },
    block: {
      width: '100%',
      height: '100%',
    },
    inline: {
      flexDirection: 'row',
      alignItems: 'center',
      '& p': { ml: 1 },
    },
  };

  return (
    <Box className={className} sx={{ ...commonSx, ...typeSx[type] }}>
      <CircularProgress size={20} />
      {label && (
        <Typography variant="body2" sx={{ mt: type === 'inline' ? 0 : 2 }}>
          {label}
        </Typography>
      )}
    </Box>
  );
};

export default LoadingIndicator;
